import { ComponentProps } from "react";

import { ContentCardLayout } from "../contents/cards/ContentCardLayout";
import { ArchiveHorizontalCard } from "./ArchiveHorizontalCard";
import { ArchiveVerticalCard } from "./ArchiveVerticalCard";

export type ArchiveItem = {
    id: string;
    title: string;
    source: string;
    sourcename: string;
    mix_archive_sourcename?: {
        imgurl?: string | null;
        source: string;
        sourcename: string;
    } | null;
    view_url: string;
    download_url: string;
    thumbnail_url?: string | null;
    tags?: Array<string> | null;
    created_at?: any | null;
    updated_at?: any | null;
    bookmarked?: boolean;
};

export const ArchiveCard = ({
    device,
    onDownload,
    isGuest = false,
    ...props
}: Omit<ComponentProps<typeof ContentCardLayout>, "children"> & {
    archive: ArchiveItem;
    tagEnums: Array<{ value: string; comment?: string | null }>;
    onClick?: () => void;
    onDownload?: (e: React.MouseEvent) => void;
    device?: "web+tablet" | "app";
    isGuest?: boolean;
}) => {
    const map = {
        "web+tablet": (
            <ArchiveVerticalCard
                {...props}
                onDownload={onDownload}
                isGuest={isGuest}
            />
        ),
        app: (
            <ArchiveHorizontalCard
                {...props}
                onDownload={onDownload}
                isGuest={isGuest}
            />
        )
    };

    return device ? (
        map[device]
    ) : (
        <>
            <ArchiveVerticalCard
                className="!hidden md:!flex"
                {...props}
                onDownload={onDownload}
                isGuest={isGuest}
            />
            <ArchiveHorizontalCard
                className="!flex md:!hidden"
                {...props}
                onDownload={onDownload}
                isGuest={isGuest}
            />
        </>
    );
};
